import {
  corporateLogin,
  harmoniLogin,
  partnerLogin,
} from "../components/image-assets-list/imagepath";

export const statusOptions = [
  { label: "ACTIVE", value: "ACTIVE" },
  { label: "INACTIVE", value: "INACTIVE" },
  { label: "SUSPENDED", value: "SUSPENDED" },
];

/*This is Role type for the user dont have the create, update and delete options for modules */
export const ROLE_DENIED_ACCESS = ["VIEWER"];

export const ROLE_ACCESS_TYPE = [
  { label: "Editor", value: "EDITOR" },
  { label: "Viewer", value: "VIEWER" },
];

export const LOGIN_COOKIES = {
  AUTHENTICATED: "authenticated",
  ACCESS_TOKEN: "accessToken",
  REFRESH_TOKEN: "refreshToken",
  LOGGEDIN_PANEL: "loggedInPanel",
};

export const ALL_PANELS = {
  CORPORATE: "CORPORATE",
  PARTNER: "PARTNER",
  HARMONI: "HARMONI",
};

export const PANELS = {
  CORPORATE: "corporate",
  PARTNER: "partner",
  HARMONI: "harmoni",
};

export const PAGINATION_PER_PAGE = 10;

export const SERVICE_CATEGORY = [
  { label: "Fitness", value: "FITNESS" },
  { label: "Sports", value: "SPORTS" },
  { label: "Wellness", value: "WELLNESS" },
  { label: "Medical", value: "MEDICAL" },
];

export const EDUCATION = [
  // { label: "12", value: "12" },
  { label: "Certification", value: "Certification" },
  { label: "Diploma", value: "Diploma" },
  { label: "Graduation", value: "Graduation" },
  { label: "Masters", value: "Masters" },
  { label: "PhD", value: "PhD" },
];

export const userTypeMapping = {
  corporate: {
    userType: "Corporate",
    pathname: "corporate",
    image: corporateLogin,
  },
  partner: {
    userType: "Partner",
    pathname: "partner",
    image: partnerLogin,
  },
  harmoni: {
    userType: "Harmoni Employee",
    pathname: "harmoni",
    image: harmoniLogin,
  },
};

export const billingTypesConfig = [
  { label: "Weekly", value: "WEEKLY", duration: { value: 7, unit: "DAY" } },
  { label: "Monthly", value: "MONTHLY", duration: { value: 30, unit: "DAY" } },
  {
    label: "Quarterly",
    value: "QUARTERLY",
    duration: { value: 90, unit: "DAY" },
  },
  {
    label: "Half Yearly",
    value: "HALF_YEARLY",
    duration: { value: 180, unit: "DAY" },
  },
  { label: "Yearly", value: "YEARLY", duration: { value: 365, unit: "DAY" } },
  {
    label: "Per Session",
    value: "PER_SESSION",
    duration: { value: 1, unit: "SESSION" },
  },
  { label: "Hourly", value: "HOURLY", duration: { value: 1, unit: "HOUR" } },
  { label: "Per Test", value: "PER_TEST", duration: { value: 0, unit: "N/A" } },
];

export const SERVICES_ACTIVITY_TYPE = [
  { value: "INDIVIDUAL", label: "Individual" },
  { value: "GROUP", label: "Group" },
];

export const KYB_STATUS_OPTIONS = [
  { value: "APPROVED", label: "Approved" },
  { value: "PENDING", label: "Pending" },
];

export const KYB_LIST = {
  APPROVED: "APPROVED",
  PENDING: "PENDING",
  REJECTED: "REJECTED",
};


export const PARTNER_ACTIVE_BARNCH_SESSION_KEY="selectedBranchId"